import { WarehouseIcon } from "@phosphor-icons/react/Warehouse";
import { Dropdown } from "@freightsimple/ui-core/Controls/Dropdown";
import { Icon } from "@freightsimple/ui-core/Icons/Icon";
import distributionWarehouseBrands from "@/GeneratedFixtures/DistributionWarehouseBrands.json";
import { DistributionWarehouseBrandImg } from "../CustomComponents/DistributionWarehouseBrandImg";

interface DistributionWarehouseBrandDropdownProps {
  selectedItem: string | null | undefined;
  onOptionSelected: (option: string | undefined) => void;
}

function getDistributionWarehouseBrandOptions() {
  const brands = distributionWarehouseBrands;
  return [
    ...brands
      .map((brand) => ({
        value: brand.identifier,
        label: brand.displayName,
        icon: <DistributionWarehouseBrandImg img={brand.logo} />,
      }))
      .sort((a, b) => a.label.localeCompare(b.label)),
    {
      value: "other",
      label: "Other",
      icon: <Icon icon={WarehouseIcon} weight="fill" />,
    },
  ];
}

export function DistributionWarehouseBrandDropdown(
  props: DistributionWarehouseBrandDropdownProps,
) {
  const options = getDistributionWarehouseBrandOptions();
  return (
    <Dropdown
      value={props.selectedItem ?? undefined}
      onChange={props.onOptionSelected}
      options={options}
      placeholder="Select a brand"
      data-testid="distribution-warehouse-brand-dropdown"
      // Fills its column, like its siblings. Only shows for distribution
      // warehouses, which is why it kept the overhanging fixed token longer.
      width="full"
    />
  );
}
